import { createFormatters } from "@indietabletop/appkit";

type EnglishLocale = "en" | `en-${string}`;

function createCurrencyFmt(locale: EnglishLocale) {
  // Previously used currencies are cached
  const cache = new Map<string, Intl.NumberFormat>();

  return (currency: string, amount: number) => {
    let formatter = cache.get(currency);

    if (!formatter) {
      formatter = Intl.NumberFormat(locale, { style: "currency", currency });
      cache.set(currency, formatter);
    }

    return formatter.format(amount / 100);
  };
}

// TODO: Move currency to AppKit
function createFmt(locale: EnglishLocale) {
  return {
    ...createFormatters(locale),
    currency: createCurrencyFmt(locale),
  };
}

export const fmt = createFmt("en-US");
